<template>
    <div >

        <div class="row">
             <div class="row">
                <div class="col-6">
                    <!-- //espaço em branco// -->
                </div>
                <div class="col-6">
                    <ol style="float: right;" class="breadcrumb ">
                        <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                        <!-- <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Colaboradores</a></li> -->
                        <li class="breadcrumb-item active">RELATÓRIO ESPELHO DE PONTO</li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-2" >
                        <div class="form-group">
                            <label for="">Data Início</label>
                            <input type="date" v-model="pdatainicio" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-2" >
                        <div class="form-group">
                            <label for="">Data Fim</label>
                            <input type="date" v-model="pdatafim" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4">
                        <span class="lblselect2">Colaborador:</span>
                        <select id="cbcolaborador" data-placeholder="Selecione uma opção" data-allow-clear="true"
                            style="width:100%;" v-model="vidcolaborador">
                        </select>
                    </div>
                    <div class="col-lg-2" style="padding-top: 25px;">
                        <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                            <i class="bi bi-search"></i> Listar
                        </a>
                    </div>

                    <div class="col-lg-2" style="padding-top: 25px;">
                        <div class="dropdown">
                            <a class="btn btn-secondary dropdown-toggle" style="width: 100%;" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                               Outros
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" @click.prevent="mtdexportar(1)" href="#">Imprimir</a></li>
                                <li><a class="dropdown-item" @click.prevent="mtdexportar(2)" href="#">Excel</a></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div> 
        </div>

        <div class="row">
            <!-- Conteúdo do relatório aqui -->
             <div class="card mb-3">
                <table class="table table-striped table-sm table-hover">
                    <thead class="table">
                        <tr>
                            <th>Data</th>
                            <th>Dia</th>
                            <th>Entrada (NSR)</th>
                            <th>Saída (NSR)</th>
                            <th>Entrada (NSR)</th>
                            <th>Saída (NSR)</th>
                            <th>Total Dia</th>
                            <th>Observação/Justificativa</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="lstespelho.length === 0">
                            <td colspan="8" class="text-center text-muted">Nenhum resultado encontrado</td>
                        </tr>
                        <tr v-for="(item, index) in lstespelho" :key="index">
                            <td>{{ item.data }}</td>
                            <td>{{ item.dia }}</td>
                            <td>{{ item.entrada1 }}</td>
                            <td>{{ item.saida1 }}</td>
                            <td>{{ item.entrada2 }}</td>
                            <td>{{ item.saida2 }}</td>
                            <td>{{ item.totaldia }}</td>
                            <td>{{ item.obs }}</td>
                        </tr>   
                    </tbody>
                </table>
             </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="alert alert-info" role="alert">
                                    <strong>Total Trabalhado</strong>
                                    <h4 class="mt-2 mb-0">{{ total_trabalhado }}</h4>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="alert alert-success" role="alert">
                                    <strong>Total Extras</strong>
                                    <h4 class="mt-2 mb-0">{{ total_extras }}</h4>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="alert alert-warning" role="alert">
                                    <strong>Total Faltas</strong>
                                    <h4 class="mt-2 mb-0">{{ total_faltas }}</h4>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="alert alert-secondary" role="alert">
                                    <strong>Adicional Noturno</strong>
                                    <h4 class="mt-2 mb-0">{{ adicional_noturno }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        </div>   

    </div>
</template>

<script>

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


import util from '../../util.js'
export default {
    name: 'RelEspelhodePonto',
    data() {
        return {
            // dados aqui
            pdatainicio   : '',
            pdatafim      : '',
            vidcolaborador: null,  

            lstespelho: [],

            total_trabalhado: '00:00',
            total_extras: '00:00', 
            total_faltas: '00:00', 
            adicional_noturno: '00:00'

        }
    },
    methods: {
        // métodos aqui
      mtdexportar(tipo) {
            const vself = this;
            
            // Define o arquivo base
            const urlBase = util.servidor +'/controller/relatorios.php'; 

            // Monta o objeto de parâmetros
            const params = {
                op: 'relatorioespelhoponto',
                idempresa: vself.$store.state.usuario.idempresa,
                idcolaborador: vself.vidcolaborador,
                datainicio: vself.pdatainicio,
                datafim: vself.pdatafim,
                exportar: tipo // 1 para Imprimir, 2 para Excel
            };

            // Converte o objeto em uma string de consulta (Query String)
            const queryString = new URLSearchParams(params).toString();

            // Abre em uma nova aba (_blank)
            window.open(`${urlBase}?${queryString}`, '_blank');
        },
        mtdexecutapesquisa() {
            let vself = this;

            if(vself.vidcolaborador === null){
                util.notif('error', 'Atenção', 'Selecione um colaborador para gerar o relatório.');
                return
            }
            if(vself.pdatainicio === ''){
                util.notif('error', 'Atenção', 'Informe a data de início para gerar o relatório.');
                return
            }
            if(vself.pdatafim === ''){
                util.notif('error', 'Atenção', 'Informe a data fim para gerar o relatório.');
                return
            }

            let parametros = [
                { parametro: 'op',             valor: 'relatorioespelhoponto' },
                { parametro: 'idempresa',      valor: vself.$store.state.usuario.idempresa },
                { parametro: 'idcolaborador',  valor: vself.vidcolaborador },
                { parametro: 'datainicio',     valor: vself.pdatainicio },
                { parametro: 'datafim',        valor: vself.pdatafim },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/relatorios.php');
            retorno.then(function (response) {
                vself.lstespelho = response.data.registros;


                vself.total_trabalhado    = response.data.resumo.total_trabalhado;
                vself.total_extras        = response.data.resumo.total_extras; 
                vself.total_faltas        = response.data.resumo.total_faltas;
                vself.adicional_noturno   = response.data.resumo.adicional_noturno;
            }).catch(function (error) {
                console.log(error);
            });
        },  
    },
    mounted() {

        let vself = this;

        $("#cbcolaborador").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbcolaboradores ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidcolaborador = $("#cbcolaborador").val();
        });
    }
}
</script>

<style>

</style>